export default __webpack_public_path__ + "static/media/calendar.5d46ebd8.svg";